<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { showAddUsersModal } from "../AddUserModal/stores";

  const onclick = () => {
    $showAddUsersModal = true;
  };
</script>

<Button kind="tertiary" leadingIcon="fas fa-plus" {onclick}>Add Users</Button>
